export enum UserRole {
  BANNED = 0,
  DEACTIVATE = 1,
  GUEST = 2,
  MEMBER = 3,
  MODERATOR = 4,
  ADMINISTRATOR = 5,
  OWNER = 6
}

export interface Config {
  hasPermission: (expectedMinRole: UserRole) => boolean;
}

export function usePermission(role?: number): Config {
  return {
    hasPermission: (expectedMinRole: UserRole): boolean => {
      return role != undefined && role >= expectedMinRole;
    }
  };
}


function getCookie(name: string): string | undefined {
  const value = `; ${document.cookie}`;
  const parts: string[] = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()!.split(';').shift();
}